import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import factoryLogger from '../../logger/index.js'
import {BreadcrumbErrorsFactory} from '../Errors/factory.js'
import BreadcrumbMappersFactory from '../Mappers/factory.js'
import HttpBreadcrumbRepository from './HttpBreadcrumbRepository.js'

export default class BreadcrumbRepositoriesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {HttpBreadcrumbRepository}
   * @property {Config} config
   * @property {Fetcher} fetcher
   * @property {Function} adsValueObject
   * @property {Function} adEntityFactory
   * @property {Function} adsSearchParamsHttpToValueObjectMapperFactory
   * @property {Function} adsSearchParamsValueObjectToHttpMapperFactory
   * @property {Function} adsSearchParamsValueObjectFactory
   * @property {Function} log
   */
  static httpBreadcrumbRepository = ({config}) =>
    new HttpBreadcrumbRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      fromRawBreadcrumbResponseToDetailBreadcrumbVOMapper:
        BreadcrumbMappersFactory.fromRawBreadcrumbResponseToDetailBreadcrumbVOMapper({
          config
        }),
      fromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper:
        BreadcrumbMappersFactory.fromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper({
          config
        }),
      getBreadcrumbsErrorFactory: BreadcrumbErrorsFactory.getBreadcrumbs,
      log: factoryLogger({prefix: 'HttpBreadcrumbRepository'})
    })
}
